import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import PopupForm from './PopupForm';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState('register_now');
  const navigate = useNavigate();

  const handleProgramsClick = (e) => {
    // smooth-scroll to programs section on the homepage
    e.preventDefault();
    setIsMenuOpen(false);
    const scrollToPrograms = () => {
      const el = document.getElementById('programs');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // fallback: navigate to root with hash
        window.location.href = '/#programs';
      }
    };

    if (window.location.pathname === '/') {
      scrollToPrograms();
    } else {
      navigate('/');
      // wait for navigation/render then scroll
      setTimeout(scrollToPrograms, 200);
    }
  };

  return (
    <header className="header" role="banner">
      <div className="header-inner">
        <div className="logo-container">
          <Link to="/" className="logo-link" aria-label="Lead With Tech home">
            <img src="/images/lwt.png" alt="Lead With Tech" height={50} width={120} />
          </Link>
        </div>

        <button
          className="mobile-menu-btn"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>

        <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`} role="navigation" aria-label="Main navigation">
          <Link to="/about" onClick={() => setIsMenuOpen(false)}>ABOUT</Link>
          <a href="/#programs" onClick={handleProgramsClick}>PROGRAMS</a>
          <a
            href="/career-authoring"
            onClick={e => {
              e.preventDefault();
              setIsMenuOpen(false);
              const scrollToCareerAuthoring = () => {
                const el = document.querySelector('.career-authoring-section');
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                  window.location.href = '/career-authoring';
                }
              };
              if (window.location.pathname === '/') {
                scrollToCareerAuthoring();
              } else {
                navigate('/');
                setTimeout(scrollToCareerAuthoring, 200);
              }
            }}
          >
            CAREER AUTHORING
          </a>
          <Link to="/jobs" onClick={() => setIsMenuOpen(false)}>JOBS</Link>
          <Link to="/events" onClick={() => setIsMenuOpen(false)}>EVENTS</Link>
          {/* <Link to="/webinars" onClick={() => setIsMenuOpen(false)}>WEBINARS</Link>*/}
          {/* <Link to="/blog" onClick={() => setIsMenuOpen(false)}>BLOGS</Link>  */}
          <Link to="/contact" onClick={() => setIsMenuOpen(false)}>CONTACT</Link>
     
        </nav>
      </div>

      <PopupForm 
        isOpen={isPopupOpen} 
        onClose={() => setIsPopupOpen(false)} 
        formType={popupType}
      />
    </header>
  );
}

export default Header;